import { createSlice } from "@reduxjs/toolkit";
import { updateAdminAPI } from "../../services/adminManagement";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const updateAdminSlice = createSlice({
  name: "updateAdmin",
  initialState: data,
  reducers: {
    updateAdminInfo(state) {
      state.isLoading = true;
    },
    updateAdminInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    updateAdminInfoFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    updateAdminInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const updateAdminHandler = (payload) => async (dispatch) => {
  try {
    dispatch(updateAdminAction.updateAdminInfo());
    const response = await updateAdminAPI(payload);
    dispatch(updateAdminAction.updateAdminInfoSuccess(response));
  } catch (e) {
    dispatch(updateAdminAction.updateAdminInfoFailure(e));
  }
};

export default updateAdminSlice.reducer;
export const updateAdminAction = updateAdminSlice.actions;
